// Imperative per-frame delivery channel for triangulation drag updates.
//
// Publishing a drag frame through React state re-renders the entire ViewerPage
// plus every mounted Viewport on every pointer frame, which multiplies by
// viewport count and starves the accepted-image pipeline. This channel delivers
// the latest triangulation point and per-viewport sync commands imperatively;
// only the small per-pane overlay layers subscribe via useSyncExternalStore and
// the follower scheduling path consumes commands directly. React state remains
// the durable authority for gesture anchors (phase 'set') and clears (null) so
// late-mounting viewports still seed correctly from props.
export const VIEWPORT_TRIANGULATION_DRAG_CHANNEL_MARKER = 'KAIROS_VIEWPORT_TRIANGULATION_DRAG_CHANNEL';

const EMPTY_CHANNEL_STATE = Object.freeze({ version: 0, payload: null });

export const createViewportTriangulationDragChannel = () => {
  let state = EMPTY_CHANNEL_STATE;
  const subscribers = new Set();
  return {
    marker: VIEWPORT_TRIANGULATION_DRAG_CHANNEL_MARKER,
    publish(payload) {
      state = { version: state.version + 1, payload: payload || null };
      subscribers.forEach((subscriber) => {
        try { subscriber(state.payload); } catch (_) { /* subscriber isolation */ }
      });
    },
    subscribe(subscriber) {
      if (typeof subscriber !== 'function') return () => {};
      subscribers.add(subscriber);
      return () => subscribers.delete(subscriber);
    },
    getSnapshot() {
      return state;
    },
  };
};

// Stable no-channel fallbacks so useSyncExternalStore hook order never depends
// on channel presence.
export const emptyTriangulationDragSubscribe = () => () => {};
export const emptyTriangulationDragSnapshot = () => EMPTY_CHANNEL_STATE;
